import bwipjs from 'bwip-js';
import { Component } from 'react';
import { connect } from 'react-redux';

import { Badge, Button, Heading, Pane, SelectMenu } from 'evergreen-ui';
import { deleteEventReservation, getEventReservation, updateEventReservation } from '../actions/EventReservationActions';

import { Link } from 'react-router-dom';
import DeleteDialog from '../../common/DeleteDialog/DeleteDialog';
import InfoBlock from '../../common/InfoBlock/InfoBlock';
import InfoLine from '../../common/InfoBlock/InfoLine';

const STATUS_COLORS = {
    pending: 'yellow',
    confirmed: 'green',
    cancelled: 'red',
    checked_in: 'blue',
    no_show: 'neutral'
};

const STATUS_LABELS = {
    pending: 'In asteptare',
    confirmed: 'Confirmat',
    cancelled: 'Anulat',
    checked_in: 'Check-in',
    no_show: 'Absent'
};

const PAYMENT_STATUS_COLORS = {
    unpaid: 'yellow',
    paid: 'green',
    refunded: 'orange'
};

const PAYMENT_STATUS_LABELS = {
    unpaid: 'Neplatit',
    paid: 'Platit',
    refunded: 'Rambursat'
};

class ViewEventReservation extends Component {
    constructor(props) {
        super(props);
        this.id = this.props.params.id;
    }

    async componentDidMount() {
        await this.props.dispatch(getEventReservation(this.id))
    }

    componentDidUpdate(prevProps) {
        if (this.props.reservation && this.props.reservation.confirmationCode &&
            (!prevProps.reservation || prevProps.reservation.confirmationCode !== this.props.reservation.confirmationCode)) {
            try {
                const canvas = document.getElementById(`qr-reservation-${this.props.reservation.confirmationCode}`);
                if (canvas) {
                    canvas.width = 64;
                    canvas.height = 64;
                    bwipjs.toCanvas(canvas, {
                        bcid: 'qrcode',
                        text: `reservation:load:${this.props.reservation.confirmationCode}`,
                        scale: 3,
                        height: 7,
                        width: 7,
                        includetext: false
                    });
                }
            } catch (error) {
                console.error('Error generating QR code:', error);
            }
        }
    }

    handleDelete = () => {
        this.props.dispatch(deleteEventReservation(this.id));
    }

    handleStatusChange = (status) => {
        const { reservation } = this.props;
        this.props.dispatch(updateEventReservation(this.id, {
            eventId: reservation.eventId,
            name: reservation.name,
            email: reservation.email,
            phone: reservation.phone,
            status: status,
            paymentStatus: reservation.paymentStatus,
            paymentTypeId: reservation.paymentTypeId,
            amount: reservation.amount,
            notes: reservation.notes
        }));
    }

    handlePaymentStatusChange = (paymentStatus) => {
        const { reservation } = this.props;
        this.props.dispatch(updateEventReservation(this.id, {
            eventId: reservation.eventId,
            name: reservation.name,
            email: reservation.email,
            phone: reservation.phone,
            status: reservation.status,
            paymentStatus: paymentStatus,
            paymentTypeId: reservation.paymentTypeId,
            amount: reservation.amount,
            notes: reservation.notes
        }));
    }

    render() {
        const { reservation } = this.props;

        return (
            <Pane padding={16} paddingTop={0}>
                <Pane display="flex" gap={16}>
                    <Pane>
                        <Link to="/event-reservations">
                            <Button iconBefore="arrow-left">
                                Inapoi la lista rezervari
                            </Button>
                        </Link>
                    </Pane>

                    <Pane>
                        <Link to={`/event-reservations/${this.id}/edit`}>
                            <Button iconBefore="edit" appearance="primary">
                                Editeaza
                            </Button>
                        </Link>
                    </Pane>

                    <Pane>
                        <DeleteDialog
                            onDelete={this.handleDelete}
                            buttonLabel="Sterge rezervarea"
                            title="Confirmare stergere rezervare"
                            confirmLabel="Sterg definitiv rezervarea"
                            message="Esti sigur ca vrei sa stergi aceasta rezervare?" />
                    </Pane>
                </Pane>

                <Pane flex={1} background="tint1" elevation={1} padding={16} marginTop={16} display="flex" alignItems="center" justifyContent="space-between">
                    <Heading size={600}>
                        Rezervare - <strong>{reservation.confirmationCode}</strong>
                    </Heading>
                    <Pane display="flex" flexDirection="column" alignItems="center">
                        <Pane
                            padding={2}
                            background="white"
                            borderRadius={4}
                            border="1px solid #E4E7EB"
                        >
                            <canvas id={`qr-reservation-${reservation.confirmationCode}`} />
                        </Pane>
                    </Pane>
                </Pane>

                <Pane display="flex" justifyContent="space-between" flex={1} marginTop={16} gap={16}>
                    <InfoBlock flex="50%" label="Detalii Rezervare">
                        <InfoLine label="Cod Confirmare" value={reservation.confirmationCode} />
                        <InfoLine label="Nume" value={reservation.name} />
                        <InfoLine label="Email" value={reservation.email} />
                        <InfoLine label="Telefon" value={reservation.phone} />
                        <InfoLine label="Suma" value={reservation.amount ? `${reservation.amount} RON` : '-'} />
                        <InfoLine label="Note" value={reservation.notes || '-'} />
                        <InfoLine label="Data Rezervare" value={new Date(reservation.createdAt).toLocaleString('ro-RO')} />
                    </InfoBlock>

                    <InfoBlock flex="50%" label="Eveniment">
                        {reservation.event && (
                            <>
                                <InfoLine label="Titlu" value={reservation.event.title} />
                                <InfoLine label="Data" value={new Date(reservation.event.start).toLocaleString('ro-RO')} />
                                <InfoLine label="Locatie" value={reservation.event.location} />
                                <InfoLine label="Pret" value={reservation.event.price ? `${reservation.event.price} RON` : '-'} />
                            </>
                        )}
                    </InfoBlock>
                </Pane>

                <Pane display="flex" gap={16} marginTop={16}>
                    <InfoBlock flex="50%" label="Status Rezervare">
                        <Pane display="flex" alignItems="center" gap={16} paddingY={8}>
                            <Badge color={STATUS_COLORS[reservation.status]} size={500}>
                                {STATUS_LABELS[reservation.status] || reservation.status}
                            </Badge>
                            <SelectMenu
                                title="Schimba status"
                                options={[
                                    { label: 'In asteptare', value: 'pending' },
                                    { label: 'Confirmat', value: 'confirmed' },
                                    { label: 'Check-in', value: 'checked_in' },
                                    { label: 'Anulat', value: 'cancelled' },
                                    { label: 'Absent', value: 'no_show' }
                                ]}
                                selected={reservation.status}
                                onSelect={(item) => this.handleStatusChange(item.value)}
                            >
                                <Button>Schimba status</Button>
                            </SelectMenu>
                        </Pane>
                    </InfoBlock>

                    <InfoBlock flex="50%" label="Status Plata">
                        <Pane display="flex" alignItems="center" gap={16} paddingY={8}>
                            <Badge color={PAYMENT_STATUS_COLORS[reservation.paymentStatus]} size={500}>
                                {PAYMENT_STATUS_LABELS[reservation.paymentStatus] || reservation.paymentStatus}
                            </Badge>
                            <SelectMenu
                                title="Schimba status plata"
                                options={[
                                    { label: 'Neplatit', value: 'unpaid' },
                                    { label: 'Platit', value: 'paid' },
                                    { label: 'Rambursat', value: 'refunded' }
                                ]}
                                selected={reservation.paymentStatus}
                                onSelect={(item) => this.handlePaymentStatusChange(item.value)}
                            >
                                <Button>Schimba status plata</Button>
                            </SelectMenu>
                        </Pane>
                        {reservation.paymentType && (
                            <InfoLine label="Metoda plata" value={reservation.paymentType.name} />
                        )}
                    </InfoBlock>
                </Pane>
            </Pane>
        )
    }
}

function mapStateToProps(state) {
    return {
        reservation: state.eventReservations.current
    }
}

export default connect(mapStateToProps)(ViewEventReservation);
